import { Action } from 'redux'
import { InvoiceActions } from '../../reducers/invoice/actionNames'

const requestInvoice = (id: string): IRequestInvoice => ({
  id,
  type: InvoiceActions.Request,
})

export interface IRequestInvoice extends Action<InvoiceActions.Request> {
  id: string
}

export default requestInvoice
